import React from 'react';

const colors = {
  // Backgrounds
  darkBg: '#0a0b12',
  creamBg: '#faf6f0',
  darkSurface: 'rgba(26, 20, 16, 0.04)',
  darkSurfaceHover: 'rgba(26, 20, 16, 0.07)',
  cream: '#faf6f0',

  // Text (on cream)
  textPrimary: '#1a1410',
  textSecondary: '#7a6b60',
  textMuted: 'rgba(26, 20, 16, 0.38)',
  darkText: '#1a1410',

  // Gold accents
  gold: '#c9956e',
  goldBright: '#e0a96d',
  goldDim: 'rgba(201, 149, 110, 0.18)',
  lightGold: 'rgba(201, 149, 110, 0.12)',
  shimmerGold: 'linear-gradient(135deg, #e0a96d 0%, #c9956e 50%, #a97245 100%)',
  oliveGreen: '#c9956e',
  darkOlive: '#e0a96d',
  warmAmber: '#c9956e',
  bronzeGold: '#a97245',
  antiqueGold: '#b8863c',
  goldenGlow: '#e0a96d',
  spiralGold: '#c9956e',

  // Cosmic accents
  twilightPurple: '#7b5ea7',
  violetDim: 'rgba(123, 94, 167, 0.08)',
  cosmicPink: '#c4819b',

  // Other
  deepBlue: '#1a1f35',
  celestialTeal: '#4a9b99',

  // Borders (on cream)
  borderSubtle: 'rgba(26, 20, 16, 0.1)',
  borderGold: 'rgba(201, 149, 110, 0.3)',
};

function TabNavigation({ activeTab, onTabChange }) {
  const mainTabs = [
    { id: 'calculator', label: 'Birth Chart' },
    { id: 'transits-group', label: 'Transits' },
  ];

  const transitSubtabs = [
    { id: 'calendar', label: "Today's Sky" },
    { id: 'year-calendar', label: 'Transit Calendar' },
  ];

  const isTransitsActive = activeTab === 'calendar' || activeTab === 'year-calendar';

  return (
    <div style={{ marginBottom: '40px' }}>
      {/* Main tabs */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '48px',
        marginBottom: isTransitsActive ? '0' : '40px',
        borderBottom: `1px solid ${colors.borderSubtle}`,
        paddingBottom: '0',
      }}>
        {mainTabs.map(tab => {
          const isActive = tab.id === 'calculator' ? activeTab === 'calculator' : isTransitsActive;
          return (
            <button
              key={tab.id}
              onClick={() => {
                if (tab.id === 'transits-group') {
                  onTabChange('calendar'); // Default to Daily Transits
                } else {
                  onTabChange(tab.id);
                }
              }}
              style={{
                background: 'none',
                border: 'none',
                borderBottom: isActive ? `1px solid ${colors.gold}` : '1px solid transparent',
                color: isActive ? colors.textPrimary : colors.textSecondary,
                fontSize: '11px',
                fontFamily: 'inherit',
                fontWeight: '500',
                letterSpacing: '2.5px',
                textTransform: 'uppercase',
                padding: '0 0 20px 0',
                cursor: 'pointer',
                transition: 'color 0.3s ease, border-color 0.3s ease',
                marginBottom: '-1px',
              }}
              onMouseEnter={(e) => {
                if (!isActive) e.currentTarget.style.color = colors.textPrimary;
              }}
              onMouseLeave={(e) => {
                if (!isActive) e.currentTarget.style.color = colors.textSecondary;
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Transit subtabs */}
      {isTransitsActive && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '48px',
          marginBottom: '40px',
          borderBottom: `1px solid ${colors.borderSubtle}`,
          paddingBottom: '0',
          paddingTop: '16px',
        }}>
          {transitSubtabs.map(tab => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                style={{
                  background: 'none',
                  border: 'none',
                  borderBottom: isActive ? `1px solid ${colors.gold}` : '1px solid transparent',
                  color: isActive ? colors.textPrimary : colors.textSecondary,
                  fontSize: '11px',
                  fontFamily: 'inherit',
                  fontWeight: '500',
                  letterSpacing: '2.5px',
                  textTransform: 'uppercase',
                  padding: '0 0 20px 0',
                  cursor: 'pointer',
                  transition: 'color 0.3s ease, border-color 0.3s ease',
                  marginBottom: '-1px',
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.currentTarget.style.color = colors.textPrimary;
                }}
                onMouseLeave={(e) => {
                  if (!isActive) e.currentTarget.style.color = colors.textSecondary;
                }}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default TabNavigation;
export { colors };
